import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { ExpenseCategory } from './useExpensesQuery';

export const ESTIMATE_EXPENSE_ENDPOINT = '/Consumer/Expenses/EstimateExpense';

interface EstimateResult {
  EstimatedValues: { Category: ExpenseCategory; EstimatedValue: number }[];
  TotalEstimatedValue: number;
}

interface FetcherParams {
  clientId: string;
}

const estimateExpenses = ({ clientId }: FetcherParams): Promise<EstimateResult> => {
  return authFetch(urlWithParams(ESTIMATE_EXPENSE_ENDPOINT, { clientId }));
};

export const useEstimateExpensesMutation = () => {
  return useMutation(estimateExpenses);
};
